import React from 'react';
import { Typography } from '@mui/material';

const FieldLabel = ({ children, sx, ...props }) => (
  <Typography
    variant="body1"
    {...props}
    sx={{
      mb: 1,
      fontFamily: "'Sofia Pro Bold', 'Sofia Pro', sans-serif",
      fontWeight: 700,
      fontSize: '14px',
      color: '#475969',
      ...sx,
    }}
  >
    {children}
  </Typography>
);

export default FieldLabel;
